import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeDvfxIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.51 11.14L18.81 8.32001L15.94 0.650012C15.65 -0.199988 14.35 -0.199988 14.07 0.650012L11.19 8.32001L6.49001 11.14C5.85001 11.5 5.85001 12.5 6.49001 12.85L11.19 15.67L14.07 23.34C14.36 24.19 15.66 24.19 15.94 23.34L18.82 15.67L23.52 12.85C24.16 12.49 24.16 11.49 23.52 11.14H23.51Z"
        fill={color}
      />
      <path
        d="M5 24C7.20914 24 9 22.2091 9 20C9 17.7909 7.20914 16 5 16C2.79086 16 1 17.7909 1 20C1 22.2091 2.79086 24 5 24Z"
        fill={color}
      />
      <path
        d="M6 6.5C7.38071 6.5 8.5 5.38071 8.5 4C8.5 2.61929 7.38071 1.5 6 1.5C4.61929 1.5 3.5 2.61929 3.5 4C3.5 5.38071 4.61929 6.5 6 6.5Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeDvfxIcon.displayName = 'TimeDvfxIcon';
